
export const GET_NOTIFICATION = "GET_NOTIFICATION"
export const GET_NOTIFICATION_SUCCESS = "GET_NOTIFICATION_SUCCESS"
export const GET_NOTIFICATION_FAIL = "GET_NOTIFICATION_FAIL"

export const GET_NOTIFICATION_PAGE_SUCCESS = "GET_NOTIFICATION_PAGE_SUCCESS"

export const UPDATE_NOTIFICATION_READED = "UPDATE_NOTIFICATION_READED"
export const UPDATE_NOTIFICATION_READ_SUCCESS = "UPDATE_NOTIFICATION_READ_SUCCESS"
export const UPDATE_NOTIFICATION_READ_FAIL = "UPDATE_NOTIFICATION_READ_FAIL"